<div class="main-page-container">
   <div id="nav-bar" *ngIf="!isStandaloneRoute()">
      <div class="dropdown" (mouseenter)="toggleDropdown('fe')" (mouseleave)="closeDropdown('fe')">
         <button class="nav-bar-title" [class.active]="isActiveRoute('/fe')">
            <span class="nav-arrow">▶</span> FE-IPSOVIZ
         </button>

         <div class="dropdown-menu" *ngIf="dropdownStates.fe">
            <ng-container *ngFor="let item of navigationConfig.fe">
               <button class="nav-bar-sub-item" [routerLink]="item.route" routerLinkActive="active"
                  (click)="closeDropdown('fe')">
                  {{ item.label }}
               </button>
            </ng-container>
         </div>
      </div>

      <div class="dropdown" (mouseenter)="toggleDropdown('water')" (mouseleave)="closeDropdown('water')">
         <button class="nav-bar-title" [class.active]="isActiveRoute('/water-disposal')">
            <span class="nav-arrow">▶</span> Water Disposal
         </button>

         <div class="dropdown-menu" *ngIf="dropdownStates.water">
            <ng-container *ngFor="let item of navigationConfig.water">
               <button class="nav-bar-sub-item" [routerLink]="item.route" routerLinkActive="active"
                  (click)="closeDropdown('water')">
                  {{ item.label }}
               </button>
            </ng-container>
         </div>
      </div>

      <div class="dropdown" (mouseenter)="toggleDropdown('oilGas')" (mouseleave)="closeDropdown('oilGas')">
         <button class="nav-bar-title" [class.active]="isActiveRoute('/oil-gas-tab')">
            <span class="nav-arrow">▶</span> Oil & Gas Takeaway
         </button>

         <div class="dropdown-menu" *ngIf="dropdownStates.oilGas">
            <ng-container *ngFor="let item of navigationConfig.oilGas">
               <button class="nav-bar-sub-item" [routerLink]="item.route" routerLinkActive="active"
                  (click)="closeDropdown('oilGas')">
                  {{ item.label }}
               </button>
            </ng-container>
         </div>
      </div>
   </div>

   <div class="content-router-container" [class.home-route]="isStandaloneRoute()">
      <router-outlet></router-outlet>
   </div>
   <!-- <app-chatbot></app-chatbot> -->
</div>